import { Identifier } from "../../id";
export class ProductTypeId extends Identifier {
    constructor(id) {
        super("ProductTypeId", id);
    }
}
